module.exports = __webpack_public_path__ + "img/locationClassify.128e4186.svg";